
import { supabase } from "../../lib/supabaseClient";
import Script from "next/script";
import { Assets } from "../../src/list/Assets";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import dynamic from 'next/dynamic';
// import HorizontalScroll  from '/src/components/HorizontalScroll.js'
import { Suspense } from 'react'
import SkeletonLoader from '../../src/components/SkeletonLoader';
import Ad_728x90_Bot from '../../src/ads/Ad_728x90_Bot';
import GameCommonDis from "../../src/Description/GameCommonDis";

import { viewMoreUrls } from "../../src/list/viewMoreUrls";
import styles from '../../styles/tags.module.css';
import CatDis from "../../src/Description/CatDis";
import CategoryGames  from '../../src/components/CategoryGames.js';

const Game_Components = dynamic(() => import('../../src/components/Game_Components'), {  });
const Headcom = dynamic(() => import('../../src/components/Headcom'), {  });
const CatBtn = dynamic(() => import('../../src/components/CatBtn'), {  });
const HomeDis = dynamic(() => import('../../src/Description/HomeDis'), {  });
const FooterDis = dynamic(() => import('../../src/Description/FooterDis'), {  });
const Pagination = dynamic(() => import('../../src/components/PaginationNew'), {  });
const CookieCom = dynamic(() => import('../../src/components/CookieCom'), {  });
const Searchcom = dynamic(() => import('../../src/components/Searchcom'), {  });
const BannerCom = dynamic(() => import('../../src/components/BannerCom'), {  });
const FooterCom = dynamic(() => import('../../src/components/FooterCom'), {  });
const Ad_320x50 = dynamic(() => import('../../src/ads/Ad_320x50'), {  });
const BlackScreen = dynamic(() => import('../../src/components/BlackScreen'), {  });
const Snow_fx = dynamic(() => import('../../src/fx/Snow_fx'), {  });
const HorizontalScroll = dynamic(() => import('../../src/components/HorizontalScroll'), {
  loading: () => <SkeletonLoader/>,
});


export async function getStaticPaths() {
  const { data: Categories } = await supabase.from('categories').select('name');
  return {
    paths: (Categories || []).map((page) => ({
      params: { id: page.name },
    })),
    fallback: false,
  };
}


function formatGame(game) {
  return {
    name: [game.game_name || game.title, game.slug],
    path: ['/game/' + game.slug, process.env.NEXT_PUBLIC_BASE_URL || 'https://bestgamespot.com'],
    title: game.title,
    date: game.release_date,
    brand: game.brand,
    hot: game.is_hot ? 'yes' : 'no',
    label: game.label,
    orientation: game.orientation,
    thumb: game.thumb,
    thumb_big: game.thumb_big,
    iframe: game.iframe,
    video: game.video || '',
    Walkthrough: game.walkthrough || '',
    s_dis: game.s_dis,
    l_dis: game.l_dis,
    tag: game.tags || [],
    rating: game.rating || [],
    Details: game.details || {},
    faq: game.faq || []
  };
}

// Slim version — only fields CategoryGames actually renders
function formatGameSlim(game) {
  return {
    name: [game.game_name || game.title, game.slug],
    path: ['/game/' + game.slug],
    hot: game.is_hot ? 'yes' : 'no',
    thumb: game.thumb,
    thumb_big: game.thumb_big,
    video: game.video || '',
  };
}

export async function getStaticProps({ params }) {
  // Find the category to get the tag key
  const { data: catData } = await supabase.from('categories').select('*').eq('name', params.id).single();
  const tagToFind = catData ? catData.key_name : '';
  const { data: Categories } = await supabase.from('categories').select('*');

  let allGames = [];
  let totalGamesCount = 0;
  
  if (tagToFind) {
    if (tagToFind.toLowerCase() === "new games") {
      // Fetch latest games globally
      const { data, count, error } = await supabase
        .from('bestgamespot_games')
        .select('slug, game_name, title, is_hot, thumb, thumb_big, video', { count: 'exact' })
        .order('created_at', { ascending: false, nullsFirst: false })
        .order('slug', { ascending: true })
        .range(0, 69);
      if (data) allGames = data.map(formatGameSlim);
      totalGamesCount = count || 0;
    } else {
      // Fetch games by tag, sorted by newest
      const { data, count, error } = await supabase
        .from('bestgamespot_games')
        .select('slug, game_name, title, is_hot, thumb, thumb_big, video', { count: 'exact' })
        .contains('tags', [tagToFind])
        .order('created_at', { ascending: false, nullsFirst: false })
        .order('slug', { ascending: true })
        .range(0, 69);
      if (data) allGames = data.map(formatGameSlim);
      totalGamesCount = count || 0;
    }
  }

  const { data: popularGames } = await supabase
    .from('bestgamespot_games')
    .select('slug, game_name, title, is_hot, thumb, thumb_big, video')
    .limit(50);

  return {
    props: {
      Categories: catData ? [catData] : [],
      categoryGames: allGames,
      first50Games: popularGames ? popularGames.map(formatGameSlim) : [],
      totalGamesCount
    },
    revalidate: 60,
  };
}

export default function HomePage({ Categories, categoryGames, first50Games, totalGamesCount }) {


  const path = useRouter();
  const [mobile, setMobile] = useState(false);

  
  useEffect(() => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    setMobile(isMobile);
  }, []);
  

// *************************************************************


function bottomDis(value) {
  var myCom;
  if (value.dis != null) {
    myCom = <CatDis name={value.h2} dis={value.dis} />;
  }

  return myCom;
}


function pageName(name) {
  var myArray;
  var i;
  for (i = 0; i < Categories.length; i++) {
    if (name == Categories[i].name) {
      myArray = Categories[i];
      keyWord = Categories[i];
      break;
    }
  }
  return myArray;
}



const pathName = path.query.id;
var keyWord;


const router = useRouter();
  const { page = 1 } = router.query; // Get the current page from the URL query
  const [currentPage, setCurrentPage] = useState(1);
  const gamesPerPage = 70;
  const [cachedPages, setCachedPages] = useState({ 1: categoryGames });
  const [loadingPage, setLoadingPage] = useState(false);
  
  // Reset cache if we navigate to a different category
  useEffect(() => {
    setCachedPages({ 1: categoryGames });
  }, [categoryGames]);
  
  useEffect(() => {
    const pageNum = parseInt(page, 10) || 1;
    setCurrentPage(pageNum);
    
    if (pageNum > 1 && !cachedPages[pageNum]) {
      const fetchPage = async () => {
        setLoadingPage(true);
        const currentCat = pageName(router.query.id);
        const tagToFind = currentCat ? currentCat.key_name : '';
        
        let query = supabase.from('bestgamespot_games').select('*');
        if (tagToFind && tagToFind.toLowerCase() === "new games") {
          query = query.order('created_at', { ascending: false, nullsFirst: false }).order('slug', { ascending: true });
        } else if (tagToFind) {
          query = query.contains('tags', [tagToFind]).order('created_at', { ascending: false, nullsFirst: false }).order('slug', { ascending: true });
        }
        
        const start = (pageNum - 1) * gamesPerPage;
        const end = start + gamesPerPage - 1;
        
        const { data } = await query.range(start, end);
        if (data) {
          const formatted = data.map(formatGameSlim);
          setCachedPages(prev => ({ ...prev, [pageNum]: formatted }));
        }
        setLoadingPage(false);
      };
      fetchPage();
    }
  }, [page, router.query.id, cachedPages]);
  
  const paginatedGames = cachedPages[currentPage] || [];
  

  return (
    <>
      <div className="app_cont_game">
        <Headcom
          title={pageName(pathName).title}
          s_dis={pageName(pathName).s_dis}
          path={pageName(pathName).path[1] + pageName(pathName).path[0]}
          thumb={pageName(pathName).thumb}
          logo_16={Assets[0].logo_16}
          // logo_32={Assets[0].logo_32}
          logo_192={Assets[0].logo_192}
          logo_270={Assets[0].logo_270}
          logo_512={Assets[0].logo_512}
        />
        <div>
        
          <BlackScreen />
          <div className="game-root">
            <div className="container">
           
                { pageName(pathName).key =="Homepage"&&<>
                  <div className={styles.header}>
              <h1>{pageName(pathName).h1} </h1> 
            </div>
            <div className={styles.page_dis}>
      {pageName(pathName).page_dis !=undefined && <p>{pageName(pathName).page_dis}</p>} 
      </div>
      <Game_Components gamesData={categoryGames} />
      </>}

      { pageName(pathName).key !="Homepage"&&<>
        <CategoryGames games={paginatedGames} category={pageName(pathName).h1} dis={pageName(pathName).page_dis}  />
        {!mobile && <Ad_728x90_Bot />} 
      </>}
      
      {totalGamesCount > gamesPerPage && (
        <Pagination
          totalGames={totalGamesCount}
          gamesPerPage={gamesPerPage}
          currentPage={currentPage}
        />
      )}
      
      {bottomDis(pageName(pathName))}
      <CookieCom />
      </div>
      </div>
      </div>
      </div>
      <FooterCom />
      <Snow_fx />
    </>
  );
}